import MDTypography from "components/MDTypography";

import { useCategory } from "context/CategoryContext";
import { loadingColumn, loadingRow } from "components/LoadingItemsList";

export default function data() {
  const { categories, setEditCategory, deleteCategory, loading } = useCategory();

  const handlePressEdit = (category) => {
    setEditCategory(category);
  };

  const handlePressDelete = (id) => {
    deleteCategory(id);
  };

  const categoryColumn = [
    { Header: "nome", accessor: "name", width: "80%", align: "left" },
    { Header: "action", accessor: "action", align: "center" },
    { Header: "delete", accessor: "delete", align: "center" },
  ];

  const categoryRows = Object.values(categories).map((category) => ({
    name: (
      <MDTypography display="block" variant="button" fontWeight="medium">
        {category.name}
      </MDTypography>
    ),
    action: (
      <MDTypography
        display="block"
        variant="button"
        fontWeight="medium"
        onClick={() => handlePressEdit(category)} // Passing the id to the handler
        style={{ cursor: "pointer", color: "blue" }}
      >
        Edit
      </MDTypography>
    ),
    delete: (
      <MDTypography
        display="block"
        variant="button"
        fontWeight="medium"
        onClick={() => handlePressDelete(category.id)} // Passing the id to the handler
        style={{ cursor: "pointer", color: "#eb4034" }}
      >
        Delete
      </MDTypography>
    ),
  }));

  return {
    columns: loading ? loadingColumn : categoryColumn,
    rows: loading ? loadingRow : categoryRows,
  };
}
